import {CloseOutlined} from '@ant-design/icons';
import {message} from 'antd';
import React, {useMemo} from 'react';

const FEEDBACK_KEY = 'notification-read-feedback';

const useMobileNotificationFeedback = (containerRef) => {
    const [api, holder] = message.useMessage({
        prefixCls: 'mobile-notification-message',
        getContainer: () => containerRef.current,
        maxCount: 1,
    });
    const feedback = useMemo(() => {
        const show = (type, text) => {
            if (!containerRef.current?.isConnected) return message[type](text);

            return api.open({
                key: FEEDBACK_KEY,
                type,
                duration: type === 'error' ? 5 : 3,
                content: (
                    <span className='notification-feedback-content' role={type === 'error' ? 'alert' : 'status'}>
                        <span>{text}</span>
                        <button
                            type='button'
                            className='notification-feedback-close'
                            aria-label='Закрити повідомлення'
                            onClick={() => api.destroy(FEEDBACK_KEY)}
                        >
                            <CloseOutlined aria-hidden />
                        </button>
                    </span>
                ),
            });
        };

        return {
            success: (text) => show('success', text),
            error: (text) => show('error', text),
        };
    }, [api, containerRef]);

    return [feedback, holder];
};

export default useMobileNotificationFeedback;
